import { render, staticRenderFns } from "./feeDeductionAuditList.vue?vue&type=template&id=298bf6fe&scoped=true"
import script from "./feeDeductionAuditList.vue?vue&type=script&lang=js"
export * from "./feeDeductionAuditList.vue?vue&type=script&lang=js"
import style0 from "./feeDeductionAuditList.vue?vue&type=style&index=0&id=298bf6fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298bf6fe",
  null
  
)

export default component.exports